module.exports = __webpack_public_path__ + "static/media/arena2.24cf2a8f.png";